import React from 'react';

import { IBrandLinkProps, locations } from '../types';

import { PromoLinkComponent } from './PromoLinkComponent';
import { LeadPromoLinkComponent } from './LeadPromoLinkComponent';

export const BrandLink: React.FC<IBrandLinkProps> = ({
  location,
  lead,
  id,
}) => {
  if (location === locations.LOCATION_PROMO_DASHBOARD) {
    return <PromoLinkComponent id={id} />;
  }

  return <LeadPromoLinkComponent lead={lead} />;
};
